/**
 * Console Guard - Protección de logs en producción
 * Deshabilita console.log en producción pero mantiene errores críticos
 */

(function() {
  'use strict';

  // Detectar si estamos en producción
  const isProduction = () => {
    // Método 1: Verificar el hostname
    const hostname = window.location.hostname;
    const isProductionDomain = 
      hostname === 'publikaya.com' || 
      hostname === 'www.publikaya.com' ||
      hostname.endsWith('.publikaya.com');
    
    // Método 2: Verificar variable de entorno (si existe)
    const envProduction = 
      typeof window.ENV !== 'undefined' && window.ENV === 'production';
    
    // Método 3: Verificar si NO es localhost/127.0.0.1
    const isLocalDev = 
      hostname === 'localhost' || 
      hostname === '127.0.0.1' || 
      hostname === '0.0.0.0' ||
      hostname.includes('192.168.') || // Red local
      hostname.includes('10.0.') ||     // Red local
      hostname.includes('172.');        // Red local
    
    return (isProductionDomain || envProduction) && !isLocalDev;
  };

  // Guardar los métodos originales
  const originalLog = console.log;
  const originalInfo = console.info;
  const originalDebug = console.debug;
  const originalWarn = console.warn;
  const originalError = console.error;

  if (isProduction()) {
    // En PRODUCCIÓN: Deshabilitar logs de debug
    console.log = function() {};
    console.info = function() {};
    console.debug = function() {};
    
    // MANTENER console.warn y console.error para problemas críticos
    // (pero podrías deshabilitarlos también si quieres)
    
    // Opcional: Mostrar mensaje una sola vez
    originalLog('%c🔒 Modo Producción', 'color: #10b981; font-weight: bold; font-size: 12px;');
    originalLog('%cLogs de desarrollo deshabilitados', 'color: #6b7280; font-size: 11px;');
    
  } else {
    // En DESARROLLO: Mostrar todos los logs normalmente
    originalLog('%c🔧 Modo Desarrollo', 'color: #3b82f6; font-weight: bold; font-size: 12px;');
    originalLog('%cTodos los logs están habilitados', 'color: #6b7280; font-size: 11px;');
  }

  // Exponer función para verificar modo
  window.isProductionMode = isProduction;

  // Exponer métodos originales por si se necesitan en desarrollo
  if (!isProduction()) {
    window.__console = {
      log: originalLog,
      info: originalInfo,
      debug: originalDebug,
      warn: originalWarn,
      error: originalError
    };
  }

})();
